import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoService from '../../servicos/DetalhesEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaItensEmpenhoInicio: [],
    buscaItensEmpenhoSucesso: ['itensEmpenho'],
    buscaItensEmpenhoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
}

// Ação para busca completa
Creators.buscaItensEmpenho = filtro => {
    return dispatch => {
        dispatch(Creators.buscaItensEmpenhoInicio())
        let serv = new DetalhesEmpenhoService()
        return serv
            .consultarItens(filtro)
            .then(response => dispatch(Creators.buscaItensEmpenhoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaItensEmpenhoErro(error)))
    }
}

const buscaItensEmpenhoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaItensEmpenhoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaItensEmpenhoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.itensEmpenho, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ITENS_EMPENHO_INICIO]: buscaItensEmpenhoInicio,
    [Types.BUSCA_ITENS_EMPENHO_ERRO]: buscaItensEmpenhoErro,
    [Types.BUSCA_ITENS_EMPENHO_SUCESSO]: buscaItensEmpenhoSucesso,
})
